import http from '@/utils/request'
import defaultSettings from '@/settings'

// 直接通过覆盖的方式

/**
 * 单个上传文件
 * @returns
 */
export function UploadFile(formData) {
  return http.request({
    url: 'Files/Upload',
    method: 'post',
    data: formData,
    baseURL: defaultSettings.fileManageUrl
  })
}

/**
 * 批量上传文件
 * @returns
 */
export function UploadFiles(formData) {
  return http.request({
    url: 'Files/Uploads',
    method: 'post',
    data: formData,
    baseURL: defaultSettings.fileManageUrl
  })
}


/**
 * 单个上传附件
 * @returns
 */
export function uploadCropperImages(formData) {
  return http.request({
    url: 'Files/UploadImages',
    method: 'post',
    data: formData,
    baseURL: defaultSettings.fileManageUrl
  })
}

/**
 * 裁剪Base64上传
 * @returns
 */
export function UploadFilesByBase64(formData) {
  return http.request({
    url: 'Files/UploadFilesByBase64',
    method: 'post',
    data: formData,
    baseURL: defaultSettings.fileManageUrl
  })
}